import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-[#070738] text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">COMPANY</h3>
            <p className="mb-4 text-gray-300">
              We provide exceptional services and solutions that exceed expectations.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin size={30} className="mr-2 mt-1 text-[#d40715]" />
                <span className="text-gray-300">
                  3/F, Ocean Industrial Building, 29 Tai Yip Street, Kwun Tong, Hong Kong
                </span>
              </li>
              <li className="flex items-center">
                <Phone size={20} className="mr-2 text-[#d40715]" />
                <span className="text-gray-300">+852 2570 3759</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/about" 
                  className="text-gray-300 hover:text-[#d40715] transition-colors"
                  onClick={scrollToTop}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/custom-services" 
                  className="text-gray-300 hover:text-[#d40715] transition-colors"
                  onClick={scrollToTop}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/project" 
                  className="text-gray-300 hover:text-[#d40715] transition-colors"
                  onClick={scrollToTop}
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-gray-300 hover:text-[#d40715] transition-colors"
                  onClick={scrollToTop}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-xl font-bold mb-4">Newsletter</h3>
            <p className="mb-4 text-gray-300">
              Subscribe to our newsletter to receive the latest news and updates.
            </p>
            <form className="flex flex-col space-y-2">
              <input 
                type="email" 
                placeholder="Your Email" 
                className="px-4 py-2 bg-[#131347] border border-gray-700 rounded focus:outline-none focus:border-[#d40715]"
              />
              <button 
                type="submit" 
                className="bg-[#d40715] px-4 py-2 rounded text-white font-medium hover:bg-[#ff2019] transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {new Date().getFullYear()} Hop Shing Engineering & Construction Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;